import { Link } from "react-router-dom";
import { useT } from "../../stores/uiLang";

// Run E3 B4 (C04): a real not-found page. Before this, every unknown address
// quietly redirected to the home page.
const NF_T = {
  en: {
    title: "We could not find that page",
    body: "The address may be misspelled, or the page may have moved.",
    home: "Go to the home page",
    curriculum: "See the curriculum",
    login: "Log in",
  },
  es: {
    title: "No encontramos esa página",
    body: "Puede que la dirección tenga un error, o que la página se haya movido.",
    home: "Ir a la página de inicio",
    curriculum: "Ver el currículo",
    login: "Iniciar sesión",
  },
};

export default function NotFoundPage() {
  const t = useT(NF_T);
  return (
    <main className="flex flex-col items-center justify-center pt-28 pb-20 min-h-screen px-4 text-center">
      <p className="text-sm font-semibold text-indigo-600">404</p>
      <h1 className="mt-2 text-2xl sm:text-3xl font-bold text-gray-900">{t.title}</h1>
      <p className="mt-3 text-gray-600 max-w-md">{t.body}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn btn-small">
          {t.home}
        </Link>
        <Link to="/curriculum" className="btn btn-small btn-secondary">
          {t.curriculum}
        </Link>
        <Link to="/login-portal" className="btn btn-small btn-secondary">
          {t.login}
        </Link>
      </div>
    </main>
  );
}
